import queryString from "query-string";
import { TimelineType } from "../../../interfaces/TimelineInterface";
import TabsNavi from "../../molecules/TabsNavi";

type Props = {
  sectionId: string;
  timelineType: TimelineType;
  search: string;
};

export const SectionTimelineTab = ({
  sectionId,
  timelineType,
  search,
}: Props) => {
  // FILTER-05: サマリー↔リアルタイムのタブ切替時に、選択中のフィルタ（resource_filter）を保持する。
  // タブリンクへ現在のクエリ文字列を引き継ぐことで実現する。サマリー固有の date のみ
  // ignoreDateQuery で除去し、resource_filter は維持してフィルタを初期値（すべて）に戻さない。
  return (
    <TabsNavi
      tabs={[
        {
          label: "サマリー",
          link: {
            pathname: `/sections/${sectionId}/timeline/daily`,
            search: search,
          },
          active: timelineType === TimelineType.TIMELINE_SUMMARY,
        },
        {
          label: "リアルタイム",
          link: {
            pathname: `/sections/${sectionId}/timeline`,
            search: ignoreDateQuery(search),
          },
          active: timelineType === TimelineType.TIMELINE_REALTIME,
        },
        {
          label: "成績記録",
          link: {
            pathname: `/sections/${sectionId}/timeline/examination`,
            search: ignoreDateQuery(search),
          },
          active: timelineType === TimelineType.TIMELINE_EXAMINATION,
        },
      ]}
    />
  );
};

const ignoreDateQuery = (query: string): string => {
  const queryObject = queryString.parse(query);
  if (queryObject.date) {
    delete queryObject.date;
  }

  return queryString.stringify(queryObject);
};
